import { render } from "./UserBuildings.vue?vue&type=template&id=789531e8"
import script from "./UserBuildings.vue?vue&type=script&lang=js"
export * from "./UserBuildings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__